import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import CandidateDetailsModal from "../../../components/CandidateDetailsModal";
import CRDynamic_PR_table from "../../../components/CRDynamic_PR_table";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import { API_URL } from "../../../constants";
import HTMLComponent from "../../../components/HtmlComponent";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import Select from 'react-select';
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import moment from "moment";
import EditorComponent from "../../../components/editor";

const CustomerRequirement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const passedState = location.state;

  useEffect(() => {
    dispatch(
      updateNavbarHeading(
        passedState
          ? passedState?.text == "Openings QTD"
            ? "Nice Opportunities – QTD"
            : passedState?.text
          : "Customer Requirement"
      )
    );
  }, [passedState]);

  const [customerRequirementList, setCustomerRequirementList] = useState([]);
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [pendingRevokeRecord, setPendingRevokeRecord] = useState(null);
  const [revokeRemarks, setRevokeRemarks] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [jobStatusOption, setJobStatusOption] = useState([]);
  const [requirementTypeOption, setRequirementTypeOption] = useState([]);
  const [hiringOption, setHiringTypeOption] = useState([]);
  const [showJDModal, setShowJDModal] = useState(false);
  const [jDId, setJDId] = useState(0);
  const [jobDesData, setJobDesData] = useState();
  const [showSendJd, setShowSendJd] = useState(false);
  const [JobIdSendEmail, setJobIdSendEmail] = useState();
  const [subject, setSubject] = useState("");
  const [filterFormData, setFilterData] = useState([]);
  const [emailSendJd, setEmailSendJd] = useState("");
  const [viewActionJD, setViewActionJD] = useState(0);
  const [editedJobDesData, setEditedJobDesData] = useState(jobDesData);
  const [employeeList, setEmployeeList] = useState([]);
  // const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchTerms, setSearchTerms] = useState("");
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [selectedCCEmails, setSelectedCCEmails] = useState([]);
  const [activeField, setActiveField] = useState("to");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [toSearchTerm, setToSearchTerm] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [errors, setErrors] = useState({});
  const [bandDropdownOptions, setBandDropdownOptions] = useState([]);
  const [employeeDropdownOptions, setEmployeeDropdownOptions] = useState([]);
  const [deliveryManagerDropdownOptions, setDeliveryManagerDropdownOptions] = useState([]);
  const [ccSearchTerm, setCcSearchTerm] = useState("");
  const [showFormModal1, setShowFormModal1] = useState(false);
  const modalRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [showLeadsModal, setShowLeadsModal] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [leadsLoading, setLeadsLoading] = useState(false);
  const [currentLeadReqCode, setCurrentLeadReqCode] = useState("");


  const handleLeadClick = async (reqId, reqCode) => {
    setCurrentLeadReqCode(reqCode);
    setLeadsLoading(true);
    setShowLeadsModal(true);
    try {
      const response = await GetServiceCaller(`${API_URL}requirement/${reqId}/leads`);
      if (response?.data?.status === "success" || response?.status === 200) {
        const rawData = response?.data?.taLeads || response?.data?.data || response?.data || [];
        const taOnly = Array.isArray(rawData) ? rawData.filter(lead => lead.Type === 'TA' || !lead.Type) : [];
        setSelectedLeads(taOnly);
      }
    } catch (error) {
      console.error(error);
      setSelectedLeads([]);
    } finally {
      setLeadsLoading(false);
    }
  };

  const handleModalColumn = (columnName, item) => {
    if (columnName === 'TALeadCount') {
      handleLeadClick(item.ID, item.RequisitionSubID || item.JobCode || "N/A");
    }
  };

  const columns = {
    JobCode: { text: "Job Code", align: "start", type: "Link", visible: true },
    TALeadCount: { text: "TA Leads", align: "center", type: "Modal", visible: true },
    RequisitionSubID: { text: "Requisition ID", align: "start", visible: true },
    Role: { text: "Role", align: "start", visible: true },
    PositionName: { text: "Job Title", align: "start", visible: true },
    ClientName: { text: "Client", align: "start", visible: true },
    skills: { text: "Skills", align: "start", visible: true },
    DepartmentName: { text: "Sub Skills", align: "start", visible: false },
    fullfilled: { text: "Fulfil/total", align: "center", visible: true },
    HiringType: { text: "Hiring Type", align: "start", visible: true },
    Location: { text: "Location", align: "start", visible: true },
    Experience: { text: "Tot.Exp", align: "center", visible: true },
    RExp: { text: "Rel.Exp", align: "center", visible: false },
    RomName: { text: "RMG POC", align: "start", visible: true },
    RequirementDate: { text: "Opening Date", align: "start", visible: true },
    JobStatsChangeDate: { text: "Status Change Date", align: "left", visible: false },
    BillingStartDate: { text: "Billing Start Date", align: "end", visible: false },
    AgingDays: { text: "Aging", align: "left", visible: false },
    JobStatus: { text: "Status", align: "start", visible: true },
    RequirementType: { text: "Requirement Type", align: "start", visible: false },
    // ID: { text: "Job Code", align: "start", visible: false },
    LocationType: { text: "Location Type", align: "start", visible: true },
    EngagementType: {
      text: "Engagement Type",
      align: "start",
      visible: false,
    },
    CostFrequency: { text: "Cost Frequency", align: "start", visible: false },
    Rate: { text: "Rate", align: "end", visible: false },
    Tenure: { text: "Tenure", align: "end", visible: false },
    TenureFrequency: {
      text: "Tenure Frequency",
      align: "start",
      visible: false,
    },
    Revenue: { text: "Revenue", align: "end", visible: true },
    // RequirementDate: {
    //   text: "Requirement Date",
    //   align: "center",
    //   visible: false,
    // },
    TrackName: { text: "Track", align: "start", visible: false },
    JobFamilyName: { text: "Job Family", align: "start", visible: false },
    PersonalAreaName: { text: "Personal Area", align: "start", visible: false },
    PersonalSubAreaName: { text: "Personal Sub Area", align: "start", visible: false },
    RequisitionSourceName: { text: "Requisition Source", align: "start", visible: false },
    EmployeeGroupName: { text: "Employee Group", align: "start", visible: false },
    BillingTypeName: { text: "Billing Type", align: "start", visible: false },
    RMGStatusName: { text: "RMG Status", align: "start", visible: false },
    RequisitionStatus: { text: "Requisition Status", align: "start", visible: true },
    BandName: { text: "Band", align: "start", visible: false },
    Priority: { text: "RMG Priority", align: "center", visible: false },
    CurrencyName: { text: "Cur.", align: "center", visible: false },
    ProjectType: { text: "Proj.Type", align: "center", visible: false },
    ClientPriority: { text: "C.Priority", align: "center", visible: false },
    Region: { text: "Region", align: "left", visible: false },
    ClientPOC: { text: "Client POC", align: "left", visible: false },
    AccountManager: {
      text: "Account Manager",
      align: "start",
      visible: false,
    },
    TARemarks: {
      text: "TA Remarks",
      align: "start",
      visible: false,
    },
  };

  const hiringTypeOption = [
    { value: "", label: "Select" },
    { value: "1", label: "New FTE" },
    { value: "2", label: "Contracting" },
    { value: "3", label: "ALL" },
    { value: "4", label: "Internal FTE" },
  ];

  const [formData, setFormData] = useState({
  interviewPanel1: "",
  interviewPanel2: "",
  deliveryManager: "",
  clientInterview: false,
  band: "",
  RequirementDate: "",
  minBudget: "",
  maxBudget: ""
});

const [formErrors, setFormErrors] = useState({});

const renderError = (field) => formErrors[field] && (
  <div className="text-danger small mt-1" style={{ fontSize: "11px", lineHeight: "1.2" }}>{formErrors[field]}</div>
);

const handleFormInputChange = (e) => {
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === 'checkbox' ? checked : value
  }));
};

  const handleCustomDateChange = (dateValue) => {
    if (dateValue instanceof Date && !isNaN(dateValue)) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const day = String(dateValue.getDate()).padStart(2, '0');
      const month = months[dateValue.getMonth()];
      const year = dateValue.getFullYear();
      
      const formattedString = `${day}-${month}-${year}`;

      setFormData((prev) => ({ 
        ...prev, 
        RequirementDate: formattedString 
      }));
    } 
    else if (typeof dateValue === "string") {
      setFormData((prev) => ({ 
        ...prev, 
        RequirementDate: dateValue 
      }));
    }
    else if (dateValue && dateValue.target) {
      setFormData((prev) => ({ 
        ...prev, 
        RequirementDate: dateValue.target.value 
      }));
    }
  };

// 6. Handle the modal form submission
const handleFormSubmit = async (e) => {
  e.preventDefault();
  
  const errors = {};
  if (!formData.interviewPanel1) {
    errors.interviewPanel1 = "Interview Panel 1 is required";
  }
  if (!formData.interviewPanel2) {
    errors.interviewPanel2 = "Interview Panel 2 is required";
  }
  if (!formData.deliveryManager) {
    errors.deliveryManager = "Delivery Manager is required";
  }
  if (!formData.band) {
    errors.band = "Band is required";
  }
  if (!formData.minBudget) {
    errors.minBudget = "Min Budget is required";
  }
  if (!formData.maxBudget) {
    errors.maxBudget = "Max Budget is required";
  } else if (formData.minBudget && parseFloat(formData.minBudget) > parseFloat(formData.maxBudget)) {
    errors.maxBudget = "Max Budget must be greater than or equal to Min Budget";
  }

  if (Object.keys(errors).length > 0) {
    setFormErrors(errors);
    return;
  }
  setFormErrors({});

  setIsSubmitting(true);
  console.log("Submitted TA Request Data:", formData);

  const payload = {
    RTID: selectedRecord.ID,
    PrimaryInterviewerPID: formData.interviewPanel1,
    SecondaryInterviewerPID: formData.interviewPanel2,
    deliveryManager: formData.deliveryManager,
    ClientInterview: formData.clientInterview ? 1 : 0,
    Band: formData.band,
    MinBudget: formData.minBudget,
    MaxBudget: formData.maxBudget,
  };

   console.log("PAYLOAD:", payload);

  // Your API call or submission logic goes here...
   try {
    const response = await PostServiceCaller(
      `${API_URL}resource-requisition/store`,
      payload,
       "post"
    );
    toast.success("Data saved successfully");
    console.log("Response:", response);

    setShowFormModal1(false); // Close modal after successful submit
    handleGetData();
  } catch (error) {
    toast.error("Failed to save resource requisition");
    console.error("Error saving requisition:", error);
  } finally {
    setIsSubmitting(false);
  }
};

  useEffect(() => {
    fetchSkills();
  }, []);

  const [originalData, setOriginalData] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  useEffect(() => {
    if (originalData.length === 0) return;

    const queryParams = new URLSearchParams(location.search);
    const fromDate = queryParams.get("FromDate");
    const Job_Status = queryParams.get("JobStatus");
 

    const filteredData = originalData.filter((item) => {
      const ReqDate = moment(item.RequirementDate);
      const jbStatus = moment(item.JobStatus);


      const fromCondition = fromDate
        ? ReqDate.isSameOrAfter(moment(fromDate), "day") // or 'isSameOrBefore'
        : true;

      const Fstatus = Job_Status
        ? item.JobStatus?.trim()?.toLowerCase() ===
          Job_Status?.trim()?.toLowerCase()
        : true;
      return fromCondition && Fstatus;
    });

    setCustomerRequirementList(filteredData);
  }, [location.search, originalData]);

  const [apiStatus, setApiStatus] = useState(undefined);
  const fetchSkills = async () => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}requirement?P_FromDate=&P_ToDate=&P_Id=&P_HiringType=&P_RequirementType=`,
        dispatch
      );
      setApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.headers;

        const manipulatedData = cleanedData
          ? cleanedData.map((o) => {
              const experienceText = o.Experience
                ? (String(o.Experience).includes('Year') ? o.Experience : `${o.Experience} Years`)
                : "";
              return {
                ...o,
                Experience: experienceText,
              };
            })
          : [];
        setCustomerRequirementList(manipulatedData);
        setOriginalData(manipulatedData);
        setViewActionJD(response?.data?.data?.viewaction);
        const jobStatusOption = response?.data?.data?.jobstatus.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setJobStatusOption(jobStatusOption);
        // const hiringOption = response?.data?.data?.engagement_type.map((record) => ({
        //   value: record.value,
        //   label: record.text,
        // }));
        // setHiringTypeOption(hiringTypeOption);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };
  useEffect(() => {
    fetchCustomerRequirementfilter();
  }, []);
 const handleIcon1Click = async (record) => {
    // Save the incoming selected record to access its unique ID later (e.g., record.id or record.Id)
    setSelectedRecord(record || null);
    
    // Hard reset fields immediately prior to calling resource server
    setFormData({
      employeeList: [],
      interviewPanel1: "",
      interviewPanel2: "",
      deliveryManager: "",
      band: "",
      minBudget: record?.MinBudget || record?.Budget || "", 
      maxBudget: record?.MaxBudget || "",
      RequirementDate: record?.RequirementDate || ""
    });
    setEmployeeDropdownOptions([]);
    setDeliveryManagerDropdownOptions([]);
    setBandDropdownOptions([]);
    setFormErrors({});

    setIsModalLoading(true);
    try {
      const response = await GetServiceCaller(`${API_URL}get-ta-requisition-resource-details?RTID=${record?.ID || ''}`);
      
      if (response?.status === 200) {
        const detailData = response?.data?.data || response?.data;
        
        if (detailData) {
          // 1. Map Employee Array elements directly for react-select usage
          const rawEmployees = Array.isArray(detailData.employeelist) ? detailData.employeelist : [];
          const formattedEmployees = rawEmployees.map((emp) => ({
            value: emp.value,
            label: emp.text 
          }));
          setEmployeeDropdownOptions(formattedEmployees);

          // 2. Map Delivery Manager options from client's Delivery Partners
          const rawDeliveryManagers = Array.isArray(detailData.deliveryManagers) ? detailData.deliveryManagers : [];
          const formattedDeliveryManagers = rawDeliveryManagers.map((dm) => ({
            value: dm.value,
            label: dm.text 
          }));
          setDeliveryManagerDropdownOptions(formattedDeliveryManagers);

          // 3. Map Band Array elements safely to prevent DOM node structural child crashes
          const rawBands = Array.isArray(detailData.band) ? detailData.band : [];
          const formattedBands = rawBands.map((b) => ({
            value: b.value,
            text: b.text || b.value
          }));
          setBandDropdownOptions(formattedBands);

          // 4. Consolidate into React rendering pipeline (Initializing employeeList empty)
          const existing = detailData.existingAllocation;
          setFormData({
            employeeList: [], 
            interviewPanel1: existing ? existing.PrimaryInterviewerPID : "",
            interviewPanel2: existing ? existing.SecondaryInterviewerPID : "",
            deliveryManager: (existing && existing.RomID) ? existing.RomID : (detailData.defaultDeliveryManager || (formattedDeliveryManagers.length > 0 ? formattedDeliveryManagers[0].value : "")),
            clientInterview: existing ? (existing.ClientInterview == 1) : false,
            band: existing ? existing.Band : (detailData.selectedBand || record?.band || record?.Band || ""), 
            minBudget: existing ? existing.MinBudget : (detailData.minBudget || detailData.budget || record?.MinBudget || record?.Budget || ""),
            maxBudget: existing ? existing.MaxBudget : (detailData.maxBudget || record?.MaxBudget || ""),
            RequirementDate: detailData.RequirementDate || record?.RequirementDate || ""
          });
        }
      } 
    } catch (error) {
      console.error("Error communicating with yet-requisition-resource-details endpoint", error);
    } finally {
      setIsModalLoading(false);
    }

    // Modal view visibility triggered successfully inside functional block frame
    setShowFormModal1(true);
  };

  const fetchCustomerRequirementfilter = async () => {
    setPageLoading(true);
    try {
      const response = await GetServiceCaller(`${API_URL}customer-filter-data`);
      if (response.status === 200) {
        setPageLoading(false);
        const jobStatusOptions = response?.data?.data?.jobstatus.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setJobStatusOption(jobStatusOptions);

        const reqTypeOpts = response?.data?.data?.requirement_type?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setRequirementTypeOption(reqTypeOpts);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateId, setDuplicateId] = useState(null);
  const [isDuplicating, setIsDuplicating] = useState(false);

  const handleDuplicateClick = (rec) => {
    setDuplicateId(rec.ID);
    setShowDuplicateModal(true);
  };

  const handleDuplicateConfirm = async () => {
    if (isDuplicating) return;
    setIsDuplicating(true);
    try {
      const response = await PostServiceCaller(
        API_URL + "customer-requirement/duplicate/" + duplicateId,
        {},
        "post"
      );
      if (response.status === 200) {
        toast.success(response.data.message || "Duplicated successfully");
        setShowDuplicateModal(false);
        setDuplicateId(null);
        handleGetData(); // Refresh table
      } else {
        toast.error("Failed to duplicate requirement");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to duplicate requirement");
    } finally {
      setIsDuplicating(false);
    }
  };

const handleEdit = (id) => {
    const url = `/customer-requirement/edit/${id.ID}`;
    window.open(url, "_blank"); // Opens in new tab
  };

  const handleView = () => {
    navigate(`/customer-requirement/add`);
  };

  const handleGetData = async () => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}requirement?P_FromDate=${
          filterFormData.find((o) => o.label === "From Date")
            ? filterFormData.find((o) => o.label === "From Date").value
            : "2022-01-01"
        }&P_ToDate=${
          filterFormData.find((o) => o.label === "To Date")
            ? filterFormData.find((o) => o.label === "To Date").value
            : "2029-01-01"
        }&P_Id=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : "0"
        }&P_HiringType=${
          filterFormData.find((o) => o.label === "Hiring Type")
            ? filterFormData.find((o) => o.label === "Hiring Type").value
            : 0
        }&P_RequirementType=${
          filterFormData.find((o) => o.label === "Requirement Type")
            ? filterFormData.find((o) => o.label === "Requirement Type").value
            : ""
        }`,
        dispatch
      );
      setApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.headers;
        setCustomerRequirementList(
          cleanedData
            ? cleanedData.map((o) => {
                const experienceText = o.Experience
                  ? (String(o.Experience).includes('Year') ? o.Experience : `${o.Experience} Years`)
                  : "";
                return {
                  ...o,
                  Experience: experienceText,
                };
              })
            : []
        );

        setViewActionJD(response?.data?.data?.viewaction);
        const jobStatusOption = response?.data?.data?.jobstatus.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setJobStatusOption(jobStatusOption);
        // const hiringOption = response?.data?.data?.engagement_type.map((record) => ({
        //   value: record.value,
        //   label: record.text,
        // }));
        // setHiringTypeOption(hiringTypeOption);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };

  const handleEmployeeSelection = (id) => {
    navigate(
      `/customer-requirement/employee-selection/${id.ID}/${id.Technology}`
    );
  };
  const handleInterViewStatusReport = (id) => {
    const ReqId = id.ID;
    const url = `/rom/interview-status-reports/${ReqId}`;
    window.open(url, "_blank"); // Opens in new tab
  };

  const handleJD = (columnName, id) => {
    setShowJDModal(true);
    setJDId(id.ID);
  };

  useEffect(() => {
    if (jDId) {
      fetchJDId(jDId);
    }
  }, [jDId]);

  const handleJDModalClose = () => {
    setShowJDModal(false);
  };

  const fetchJDId = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}jobdescription/${jDId || JobIdSendEmail}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.jobdescription?.[0];
        setJobDesData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Customer Requirement. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Customer Requirement:", error);
    }
  };

  useEffect(() => {
    if (JobIdSendEmail) {
      fetchJDId(JobIdSendEmail);
    }
  }, [JobIdSendEmail]);

  const handleSendJD = async (item) => {
    try {
      // Set the state values first
      setSubject(
        ` ${item.JobCode} ${item.ClientName} Position of ${
          item.Role ? item.Role : "-"
        } for ${item.Location ? item.Location : "-"} location`
      );
      setJobIdSendEmail(item.ID);
      setShowSendJd(true);

      // Make API call
      const response = await GetServiceCaller(`${API_URL}employee-details`);
      const employeeEmail = response?.data?.data?.employeelist;
      setEmployeeList(employeeEmail);
      // setFilteredEmployees(employeeEmail);
    } catch (error) {
      console.error("Error sending JD:", error);
      // Handle error (show error message to user, etc.)
    }
  };

  const filteredEmployees = employeeList.filter((employee) => {
    const searchTerm = activeField === "to" ? toSearchTerm : ccSearchTerm;
    if (!searchTerm) return true;

    const emailMatch = employee.Email?.toLowerCase().includes(
      searchTerm.toLowerCase()
    );
    const nameMatch = employee.Name?.toLowerCase().includes(
      searchTerm.toLowerCase()
    );
    return emailMatch || nameMatch;
  });
  const handleSelectEmail = (email) => {
    if (activeField === "to") {
      if (selectedCCEmails.includes(email)) {
        toast.error("This email is already selected in CC");
        return;
      }
      if (!selectedEmails.includes(email)) {
        setSelectedEmails([...selectedEmails, email]);
        setToSearchTerm(""); // Reset To search term
        document.getElementById("search-input-to").value = ""; // Clear input field
      }
    } else {
      if (selectedEmails.includes(email)) {
        toast.error("This email is already selected in To");
        return;
      }
      if (!selectedCCEmails.includes(email)) {
        setSelectedCCEmails([...selectedCCEmails, email]);
        setCcSearchTerm(""); // Reset CC search term
        document.getElementById("search-input-cc").value = ""; // Clear input field
      }
    }
    setIsDropdownOpen(false);
  };
  const removeEmail = (email, field) => {
    if (field === "to") {
      setSelectedEmails(selectedEmails.filter((e) => e !== email));
    } else {
      setSelectedCCEmails(selectedCCEmails.filter((e) => e !== email));
    }
  };
  const handleSendJDClose = () => {
    setShowSendJd(false);
    setSelectedEmails([]);
    setSearchTerms("");
    setIsDropdownOpen(false);
  };

  const formDatas = [
    { name: "Status", type: "Select", options: [...jobStatusOption] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Hiring Type", type: "Select", options: [...hiringTypeOption] },
    { name: "Requirement Type", type: "Select", options: [...requirementTypeOption] },
  ];

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleAddCustomer = () => {
    navigate("/customer-requirement/add");
  };

 const handleSendJDMail = async () => {
    setLoading(true);

    // Add validation for To emails
    if (selectedEmails.length === 0) {
      toast.error("Please Add Email in To");
      setLoading(false);
      return; // Exit early if no To emails
    }

    try {
      const response = await PostServiceCaller(
        `${API_URL}email-jobdescription`,
        {
          Subject: subject,
          Email: selectedEmails.join(", "), // To emails
          CCEmail: selectedCCEmails.join(", "),
          jobdescription: editedJobDesData,
        },
        "post"
      );

      if (response.status === 200) {
        toast.success("JD sent successfully");
        setSelectedEmails([]);
        setSelectedCCEmails([]);
        setSearchTerms("");
        setShowSendJd(false);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      console.error("Error while submitting data:", error);
      toast.error("JD Send Failed");

      if (error.response?.data?.error) {
        toast.error(error.response.data.error, { position: "top-right" });
        console.error("Server responded with status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleViewActionJD = (id) => {
    setJDId(id.ID);
    setShowJDModal(true);
  };

  const handleReset = () => {
    setFilterData([]);
    fetchSkills();
  };
const handleIcon7Click = (record) => {
  if (record.isClosed === 1) {
    toast.error("Requisition is already fulfilled, can't recall it.");
    return;
  }
  if (record.isCandidateOnboarded) {
    toast.error("Candidate already onboarded, can't revoke this requirement.");
    return;
  }
  setPendingRevokeRecord(record);
  setRevokeRemarks("");
  setShowRevokeModal(true);
};

// 2. Fires when clicking the "Submit" button inside the Revoke Modal
const handleRevokeSubmit = async () => {
  if (pendingRevokeRecord) {
    if (!revokeRemarks || revokeRemarks.trim() === "") {
      toast.error("Remarks is mandatory");
      return;
    }
    console.log("Revoking Requirement ID:", pendingRevokeRecord.ID);
    
    setIsSubmitting(true);
    try {
      const response = await PostServiceCaller(
        `${API_URL}customer-requirement/recall`,
        { 
          id: pendingRevokeRecord.ID, 
          remarks: revokeRemarks 
        },
        "post"
      );

      if (response && response.status === 200) {
        toast.success("Requirement recalled successfully");
        setShowRevokeModal(false);
        setPendingRevokeRecord(null);
        // Refresh listing if needed, or trigger reload:
        window.location.reload();
      }
    } catch (error) {
      console.error("Error recalling requirement:", error);
      toast.error("Error recalling requirement");
    } finally {
      setIsSubmitting(false);
    }
  }
};
  useEffect(() => {
    const timer = setInterval(() => {
      document.querySelectorAll("#skill-table-area table tbody tr").forEach((row) => {
        const link = row.querySelector("a");
        const jobCode = link ? link.textContent.trim() : "";
        const req = customerRequirementList.find((item) => item.JobCode === jobCode);
        const isInternal = req && (
          String(req.RequirementType).trim().toLowerCase() === "internal" ||
          String(req.RequirementType) === "6960"
        );
        row.classList.toggle("internal-row", !!isInternal);
      });
    }, 500);
    return () => clearInterval(timer);
  }, [customerRequirementList]);

  return (
    <>
      <style>
        {`
          /* Override and remove alternating striped gray backgrounds, making all standard rows white */
          #skill-table-area table tbody tr td {
            background-color: #ffffff !important;
          }

          /* Highlight Internal rows with a clean, visible light blue background and dark blue text */
          #skill-table-area table tbody tr.internal-row td, 
          #skill-table-area table tbody tr.internal-row td a {
            background-color: #E5F0FF !important;
            color: #27568B !important;
            font-weight: 600 !important;
          }
          #skill-table-area table tbody tr.internal-row:hover td {
            background-color: #D0E3FC !important;
          }

          .internal-legend {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-size: 0.85rem;
            color: #495057;
          }
          .internal-legend-swatch {
            display: inline-block;
            width: 14px;
            height: 14px;
            border-radius: 3px;
            background-color: #E5F0FF;
            border: 1px solid #27568B;
          }
        `}
      </style>
      <div className="container-fluid " id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <div className="col-12 mb-2">
              <span className="internal-legend">
                <span className="internal-legend-swatch"></span>
                Rows shown in blue mean internal requirement.
              </span>
            </div>
            <CRDynamic_PR_table
              data={customerRequirementList}
              columns={columns}
              handleModalColumn={handleModalColumn}
              itemsPerPage={8}
              searchTerm={searchTerm}
              handleReset={handleReset}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              isActionRequired={true}
              setSearchTerm={setSearchTerm}
              showIcon1={viewActionJD === 0}
              showIcon2={viewActionJD === 0}
              showIcon3={viewActionJD === 0}
              showIcon4={viewActionJD === 0}
              showIcon5={viewActionJD === 1}
              showIcon6={viewActionJD === 0}
              showIcon7={viewActionJD === 0}
              showIcon8={viewActionJD === 0}
              isFilterRequired={true}
              formDatas={formDatas}
              isSorting={true}
              handleChange={handleChange}
              filterFormData={filterFormData}
              isAddNewBtnRequired={true}
              handleAddNew={handleAddCustomer}
              handleGetData={handleGetData}
              handleIcon1={handleEdit}
              handleIcon2={handleEmployeeSelection}
              handleIcon3={handleInterViewStatusReport}
              handleIcon4={handleSendJD}
              handleIcon5={handleViewActionJD}
              handleIcon6={(rec) => handleIcon1Click(rec)}
              handleIcon7={(rec) => handleIcon7Click(rec)}
              handleIcon8={(rec) => handleDuplicateClick(rec)}
              handleIconClick={handleJD}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon2: <i class="bi bi-people-fill icons"></i>,
                Icon2Text: " Employee Selection",
                Icon3Text: "Interview Status",
                Icon3: <i class="bi bi-box-arrow-up-right icons"></i>,
                Icon4: <i class="bi bi-envelope icons"></i>,
                Icon4Text: "Send JD",
                Icon5: <i class="bi bi-eye-fill icons"></i>,
                Icon5Text: "View JD",
                Icon6: <i className="bi bi-person-plus icons"></i>,
                Icon6Text: "TA Request",
                Icon6Flag: "canTransfer",
                                  Icon7: <i className="bi bi-reply icons"></i>,
                  Icon7Text: "CallBack Req.",
                  Icon7Flag: "canRecall",
                  Icon8: <i className="bi bi-files icons"></i>,
                  Icon8Text: "Duplicate", 
              }}
            />
          </div>
        </div>
      </div>

      {/** JOb Description modal */}
      <Modal
        show={showJDModal}
        onHide={handleJDModalClose}
        dialogClassName="modal-lg"
      >
        <div
          style={{ backgroundColor: "#F2F2F4" }}
          className="card rounded border-0 m-2"
        >
          <Modal.Header scloseButton>
            <Modal.Title className="text-info">
              <div className="text-center d-flex justify-center ps-3">
                <h2 style={{ fontWeight: "800", color: "#2F2E4B" }}>
                  Job Description
                </h2>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            className="rounded m-3"
            style={{
              maxHeight: "60vh",
              overflow: "scroll",
              backgroundColor: "white",
            }}
          >
            <div className="">
              <HTMLComponent html={jobDesData} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="custom-btn " onClick={handleJDModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
      {/** JOb Description modal */}

      {/** Send JD modal */}
      <Modal
        show={showSendJd}
        onHide={() => {
          handleSendJDClose();
          setSelectedEmails([]);
          setSelectedCCEmails([]);
          setToSearchTerm("");
          setCcSearchTerm("");
          setIsDropdownOpen(false);
        }}
        dialogClassName="modal-lg"
      >
        <div
          className="card rounded-3 border-0"
          style={{ backgroundColor: "#F8FAFC" }}
        >
          <Modal.Header
            closeButton
            className="border-0 px-4"
            style={{ backgroundColor: "transparent" }}
          >
            <Modal.Title
              className="fw-semibold"
              style={{ color: "#27568B", fontSize: "20px" }}
            >
              Send Mail
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            ref={modalRef}
            className="px-4 py-3 mx-3 rounded-3"
            style={{
              maxHeight: "60vh",
              overflow: "auto",
              backgroundColor: "white",
            }}
            onClick={(e) => {
              const isInput = e.target.closest("input");
              const isDropdown = e.target.closest('[role="dropdown"]');
              if (!isInput && !isDropdown) {
                setIsDropdownOpen(false);
              }
            }}
          >
            <div className="row">
              <div className="col-md-2">
                <label
                  className="form-label fw-medium me-2"
                  style={{
                    color: "#4A5568",
                    minWidth: "70px",
                    marginTop: "7px",
                  }}
                >
                  Email
                </label>
              </div>
              <div className="col-md-10 p-0">
                <div className="mb-4 align-items-center">
                  {/* To Field */}
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      width: "100%",
                      marginBottom: "15px",
                    }}
                  >
                    <div
                      style={{
                        minWidth: "30px",
                        paddingTop: "8px",
                        paddingRight: "10px",
                        fontSize: "14px",
                        color: "#4A5568",
                        fontWeight: "500",
                      }}
                    >
                      To
                    </div>
                    <div style={{ flex: 1, position: "relative" }}>
                      <div
                        className="form-control d-flex flex-wrap align-items-center gap-2 p-2"
                        style={{
                          borderColor: "#E2E8F0",
                          minHeight: "38px",
                          cursor: "text",
                        }}
                        onClick={() => {
                          document.getElementById("search-input-to").focus();
                          setActiveField("to");
                        }}
                      >
                        {selectedEmails.map((email) => (
                          <div
                            key={email}
                            className="badge d-flex align-items-center"
                            style={{ backgroundColor: "#27568B" }}
                          >
                            {email}
                            <span
                              style={{ cursor: "pointer", marginLeft: "5px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                removeEmail(email, "to");
                              }}
                            >
                              <i className="bi bi-x"></i>
                            </span>
                          </div>
                        ))}
                        <input
                          id="search-input-to"
                          type="text"
                          className="border-0 flex-grow-1"
                          value={toSearchTerm}
                          onChange={(e) => {
                            setToSearchTerm(e.target.value);
                            setIsDropdownOpen(true);
                            setActiveField("to");
                          }}
                          onFocus={() => {
                            setIsDropdownOpen(true);
                            setActiveField("to");
                          }}
                           onKeyDown={(e) => {
                          if ((e.key === "Enter" || e.key === ",") && toSearchTerm.trim() !== "") {
                          e.preventDefault();
                          const newEmail = toSearchTerm.trim();
                          if (!selectedEmails.includes(newEmail)) {
                          setSelectedEmails([...selectedEmails, newEmail]);
                          }
                          setToSearchTerm("");
                          }
                          }}
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            minWidth: "120px",
                            padding: "0px",
                          }}
                          placeholder={
                            selectedEmails.length === 0
                              ? "Search by name or email..."
                              : ""
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* CC Field */}
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        minWidth: "30px",
                        paddingTop: "8px",
                        paddingRight: "10px",
                        fontSize: "14px",
                        color: "#4A5568",
                        fontWeight: "500",
                      }}
                    >
                      CC
                    </div>
                    <div style={{ flex: 1, position: "relative" }}>
                      <div
                        className="form-control d-flex flex-wrap align-items-center gap-2 p-2"
                        style={{
                          borderColor: "#E2E8F0",
                          minHeight: "38px",
                          cursor: "text",
                        }}
                        onClick={() => {
                          document.getElementById("search-input-cc").focus();
                          setActiveField("cc");
                        }}
                      >
                        {selectedCCEmails.map((email) => (
                          <div
                            key={email}
                            className="badge d-flex align-items-center"
                            style={{ backgroundColor: "#27568B" }}
                          >
                            {email}
                            <span
                              style={{ cursor: "pointer", marginLeft: "5px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                removeEmail(email, "cc");
                              }}
                            >
                              <i className="bi bi-x"></i>
                            </span>
                          </div>
                        ))}
                        <input
                          id="search-input-cc"
                          type="text"
                          className="border-0 flex-grow-1"
                          value={ccSearchTerm}
                          onChange={(e) => {
                            setCcSearchTerm(e.target.value);
                            setIsDropdownOpen(true);
                            setActiveField("cc");
                          }}
                          onFocus={() => {
                            setIsDropdownOpen(true);
                            setActiveField("cc");
                          }}
                           onKeyDown={(e) => {
                           if ((e.key === "Enter" || e.key === ",") && ccSearchTerm.trim() !== "") {
                           e.preventDefault();
                           const newEmail = ccSearchTerm.trim();
                           if (!selectedCCEmails.includes(newEmail)) {
                           setSelectedCCEmails([...selectedCCEmails, newEmail]);
                           }
                           setCcSearchTerm("");
                           }
                          }}
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            minWidth: "120px",
                            padding: "0px",
                          }}
                          placeholder={
                            selectedCCEmails.length === 0
                              ? "Search by name or email..."
                              : ""
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* Dropdown for search results */}
                  {isDropdownOpen && (
                    <div
                      className="position-absolute w-100 bg-white shadow-sm mt-1"
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 1000,
                        border: "1px solid #E2E8F0",
                        borderRadius: "4px",
                      }}
                    >
                      {filteredEmployees.length > 0 ? (
                        filteredEmployees.map((employee) => {
                          const isInTo = selectedEmails.includes(
                            employee.Email
                          );
                          const isInCC = selectedCCEmails.includes(
                            employee.Email
                          );
                          const isDisabled =
                            (activeField === "to" && isInCC) ||
                            (activeField === "cc" && isInTo);

                          return (
                            <div
                              key={employee.Email}
                              className={`p-2 hover-bg cursor-pointer ${
                                isDisabled ? "text-muted" : ""
                              }`}
                              style={{
                                borderBottom: "1px solid #f0f0f0",
                                backgroundColor:
                                  isInTo || isInCC ? "#e9f5ff" : "white",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              }}
                              onClick={() =>
                                !isDisabled && handleSelectEmail(employee.Email)
                              }
                            >
                              <div className="fw-medium">
                                {employee.Name || "No name"}
                              </div>
                              <div className="small">
                                {employee.Email || "No email"}
                              </div>
                              {isDisabled && (
                                <div className="text-danger small mt-1">
                                  Already in {isInTo ? "To" : "CC"}
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-2 text-muted">
                          No employees found matching your search
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Subject and Email Content sections remain the same */}
            <div className="mb-3 d-flex align-items-center">
              <label
                className="form-label fw-medium me-3"
                style={{ color: "#4A5568", minWidth: "80px" }}
              >
                Subject
              </label>
              <div style={{ flex: 1 }}>
                <input
                  type="text"
                  className="form-control p-0 border-0 border-bottom rounded-0"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  style={{
                    borderColor: "#E2E8F0",
                    boxShadow: "none",
                    borderWidth: "0 0 1px 0",
                  }}
                />
              </div>
            </div>
            <div>
              <h5
                className="fw-semibold mb-1"
                style={{ color: "#2F2E4B", fontSize: "14px" }}
              >
                Email Job Description
              </h5>
              <div
                className="border rounded-3 p-3"
                style={{ backgroundColor: "#F8FAFC" }}
              >
                <EditorComponent
                  data={jobDesData || ""}
                  onEditorChange={(content) => setEditedJobDesData(content)}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="border-0 pt-0 mt-2">
            <button
              className="cancel-btn"
              onClick={() => {
                handleSendJDClose();
                setSelectedEmails([]);
                setSelectedCCEmails([]);
                setToSearchTerm("");
                setCcSearchTerm("");
                setIsDropdownOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              disabled={loading}
              className="custom-btn"
              onClick={handleSendJDMail}
            >
              {loading ? (
                <>
                  <FaSpinner className="me-2 sm-spinner" />
                  Sending...
                </>
              ) : (
                "Send Mail"
              )}
            </button>
          </Modal.Footer>
        </div>
      </Modal>
      {/** Send JD modal */}
      {/* ==================== FORM MODAL 1 (TA REQUEST) ==================== */}
       {showFormModal1 && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div className="modal-content shadow-lg border-0 rounded-3">
                
                <div className="modal-header bg-light border-bottom-0 py-2 px-4">
                  <h5 className="modal-title fw-bold text-dark fs-6">
                    <i className="bi bi-sliders me-2 text-success"></i> Talent Resource Requisition Request
                  </h5>
                  <button type="button" className="btn-close shadow-none" onClick={() => setShowFormModal1(false)}></button>
                </div>

                <form onSubmit={handleFormSubmit}>
                  <div className="modal-body p-3">
                    
                    {/* ==================== COMPACT READ-ONLY BASIC DETAILS SECTION ==================== */}
                    <div className="mb-3 p-2 bg-light rounded-2 border">
                      <h6 className="fw-bold text-dark mb-2 pb-1 border-bottom small">
                        <i className="bi bi-info-circle me-1 text-primary"></i> Requirements Details
                      </h6>
                      <div className="row g-2">
                        
                        {/* 1. Job Title Field (mapped from PositionName) */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Job Title:</span>
                            <span className="text-dark fw-medium small text-end text-truncate" 
                                  style={{ maxWidth: "150px" }} 
                                  title={selectedRecord?.PositionName || "N/A"}>
                              {selectedRecord?.PositionName || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 2. Role Field */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Role:</span>
                            <span className="text-dark fw-medium small text-end text-truncate" 
                                  style={{ maxWidth: "150px" }} 
                                  title={selectedRecord?.Role || "N/A"}>
                              {selectedRecord?.Role || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 3. Hiring Type Field */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Hiring Type:</span>
                            <span className="text-dark fw-medium small text-end text-truncate"
                                  style={{ maxWidth: "150px" }}
                                  title={selectedRecord?.HiringType || "N/A"}>
                              {selectedRecord?.HiringType || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 4. Engagement Type Field */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Engagement Type:</span>
                            <span className="text-dark fw-medium small text-end">
                              {selectedRecord?.EngagementType || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 5. Location Field */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Location:</span>
                            <span className="text-dark fw-medium small text-end">
                              {selectedRecord?.Location || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 6. Skills Field */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Skills:</span>
                            <span className="text-dark fw-medium small text-end text-truncate" 
                                  style={{ maxWidth: "150px" }} 
                                  title={selectedRecord?.skills || "N/A"}>
                              {selectedRecord?.skills || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 7. Sub Skills Field (mapped from DepartmentName) */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Sub Skills:</span>
                            <span className="text-dark fw-medium small text-end text-truncate" 
                                  style={{ maxWidth: "150px" }} 
                                  title={selectedRecord?.DepartmentName || "N/A"}>
                              {selectedRecord?.DepartmentName || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 8. Total Exp Field (mapped from Experience) */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Total Exp:</span>
                            <span className="text-dark fw-medium small text-end">
                              {selectedRecord?.Experience || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* 9. Relevant Exp Field (mapped from RExp) */}
                        <div className="col-md-4 col-sm-6">
                          <div className="bg-white p-2 rounded border d-flex justify-content-between align-items-center" style={{ minHeight: "36px" }}>
                            <span className="text-secondary small fw-semibold me-2">Relevant Exp:</span>
                            <span className="text-dark fw-medium small text-end">
                              {selectedRecord?.RExp ? selectedRecord.RExp.replace(/(\s*years?)+$/i, ' Years') : "N/A"}
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                    {/* ============================================================================== */}

                    <h6 className="fw-bold text-dark mb-2 small">
                      <i className="bi bi-pencil-square me-1 text-success"></i> Requirements & Allocation Details
                    </h6>

                    {/* Editable Fields in 1 precise row */}
                    <div className="row g-2 align-items-start">
                      
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary small mb-1">Interview Panel 1<span className="text-danger">*</span></label>
                        <Select
                          name="interviewPanel1"
                          isSearchable={true}
                          placeholder="Search Panel 1..."
                          value={employeeDropdownOptions?.find(emp => String(emp.value) === String(formData.interviewPanel1)) || null}
                          onChange={(selectedOption) => {
                            handleFormInputChange({
                              target: { name: 'interviewPanel1', value: selectedOption ? selectedOption.value : '' }
                            });
                          }}
                          options={employeeDropdownOptions}
                          classNamePrefix="react-select"
                          styles={{
                            control: (base) => ({ ...base, minHeight: '36px', height: '36px', fontSize: '13px' }),
                            indicatorsContainer: (base) => ({ ...base, height: '36px' })
                          }}
                        />
                        {renderError('interviewPanel1')}
                      </div>
 
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary small mb-1">Interview Panel 2<span className="text-danger">*</span></label>
                        <Select
                          name="interviewPanel2"
                          isSearchable={true}
                          placeholder="Search Panel 2..."
                          value={employeeDropdownOptions?.find(emp => String(emp.value) === String(formData.interviewPanel2)) || null}
                          onChange={(selectedOption) => {
                            handleFormInputChange({
                              target: { name: 'interviewPanel2', value: selectedOption ? selectedOption.value : '' }
                            });
                          }}
                          options={employeeDropdownOptions}
                          classNamePrefix="react-select"
                          styles={{
                            control: (base) => ({ ...base, minHeight: '36px', height: '36px', fontSize: '13px' }),
                            indicatorsContainer: (base) => ({ ...base, height: '36px' })
                          }}
                        />
                        {renderError('interviewPanel2')}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary small mb-1">Delivery Manager<span className="text-danger">*</span></label>
                        <Select
                          name="deliveryManager"
                          isSearchable={true}
                          placeholder="Search Delivery Manager..."
                          value={employeeDropdownOptions?.find(emp => String(emp.value) === String(formData.deliveryManager)) || null}
                          onChange={(selectedOption) => {
                            handleFormInputChange({
                              target: { name: 'deliveryManager', value: selectedOption ? selectedOption.value : '' }
                            });
                          }}
                          options={employeeDropdownOptions}
                          isClearable={true}
                          classNamePrefix="react-select"
                          styles={{
                            control: (base) => ({ ...base, minHeight: '36px', height: '36px', fontSize: '13px' }),
                            indicatorsContainer: (base) => ({ ...base, height: '36px' })
                          }}
                        />
                        {renderError('deliveryManager')}
                      </div>
 
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary small mb-1">Band<span className="text-danger">*</span></label>
                        <Select
                          name="band"
                          isSearchable={true}
                          placeholder="Band..."
                          value={
                            bandDropdownOptions
                              ?.map(b => ({ value: b.value, label: b.text || b.label }))
                              ?.find(band => String(band.value) === String(formData.band)) || null
                          }
                          onChange={(selectedOption) => {
                            handleFormInputChange({
                              target: { name: 'band', value: selectedOption ? selectedOption.value : '' }
                            });
                          }}
                          options={bandDropdownOptions.map(b => ({ value: b.value, label: b.text || b.label }))}
                          classNamePrefix="react-select"
                          styles={{
                            control: (base) => ({ ...base, minHeight: '36px', height: '36px', fontSize: '13px' }),
                            indicatorsContainer: (base) => ({ ...base, height: '36px' })
                          }}
                        />
                        {renderError('band')}
                      </div>
 
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary small mb-1">Min Budget<span className="text-danger">*</span></label>
                        <input 
                          type="text" 
                          className="form-control border shadow-none" 
                          placeholder="Min Amount"
                          name="minBudget"
                          value={formData.minBudget || ""}
                          onChange={handleFormInputChange}
                          style={{ height: "36px", fontSize: "13px" }}
                        />
                        {renderError('minBudget')}
                      </div>
 
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary small mb-1">Max Budget<span className="text-danger">*</span></label>
                        <input 
                          type="text" 
                          className="form-control border shadow-none" 
                          placeholder="Max Amount"
                          name="maxBudget"
                          value={formData.maxBudget || ""}
                          onChange={handleFormInputChange}
                          style={{ height: "36px", fontSize: "13px" }}
                        />
                        {renderError('maxBudget')}
                      </div>

                      <div className="col-md-2">
                        <div className="form-check d-flex align-items-center h-100" style={{ minHeight: "36px", paddingBottom: "8px" }}>
                          <input 
                            className="form-check-input mt-0 me-2" 
                            type="checkbox" 
                            id="clientInterviewCheck"
                            name="clientInterview"
                            checked={formData.clientInterview || false}
                            onChange={handleFormInputChange}
                          />
                          <label className="form-check-label fw-semibold text-secondary small mb-0" htmlFor="clientInterviewCheck" style={{ cursor: 'pointer' }}>
                            Client Interview
                          </label>
                        </div>
                      </div>

 
                    </div>
                  </div>

                  <div className="modal-footer border-top-0 bg-light p-2 px-4">
                    <button type="button" className="btn btn-outline-secondary btn-sm px-3 rounded-pill fw-medium" onClick={() => setShowFormModal1(false)}>Cancel</button>
                    <button
                      type="submit"
                      className="btn btn-success btn-sm px-3 rounded-pill fw-medium text-white d-inline-flex align-items-center"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Saving...
                        </>
                      ) : (
                        "Save Changes"
                      )}
                    </button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        )}
      {/** Show Conformation Dialog Box  */}
      {showRevokeModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(1px)' }} role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '450px' }}>
            <div className="modal-content shadow-lg border-0 rounded-3">
              
              {/* Modal Header */}
              <div className="modal-header border-bottom-0 pt-4 px-4 pb-2">
                <div className="d-flex align-items-center gap-2">
                  <div className="bg-danger bg-opacity-10 p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '38px', height: '38px' }}>
                    <i className="bi bi-exclamation-circle-fill text-danger fs-5"></i>
                  </div>
                  <h5 className="modal-title fw-bold text-dark fs-5">Revoke Requirement</h5>
                </div>
                <button type="button" className="btn-close shadow-none ms-auto" onClick={() => { setShowRevokeModal(false); setPendingRevokeRecord(null); }}></button>
              </div>

              {/* Modal Body with your specific warning phrase */}
              <div className="modal-body px-4 py-3">
                <p className="text-secondary mb-1" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Are you sure you want to revoke this Requirement?
                </p>
                
                 {/* Optional: Clean contextual indicator to confirm target info */}
                {pendingRevokeRecord && (
                  <>
                    <div className="mt-2 p-2 bg-light rounded border text-muted small text-truncate">
                      <strong>Job Code:</strong> {pendingRevokeRecord.JobCode || "N/A"} | <strong>Role:</strong> {pendingRevokeRecord.Role || "N/A"}
                    </div>
                    <div className="mt-3">
                      <label className="form-label text-secondary small fw-bold mb-1">
                        Recall Remarks <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Enter remarks for recalling this requirement..."
                        value={revokeRemarks}
                        onChange={(e) => setRevokeRemarks(e.target.value)}
                        style={{ fontSize: '13px' }}
                      />
                    </div>
                  </>
                )}
              </div>

              {/* Action Footer Buttons */}
              <div className="modal-footer border-top-0 bg-light p-3 px-4 d-flex justify-content-end gap-2">
                <button 
                  type="button" 
                  className="btn btn-outline-secondary btn-sm px-4 rounded-pill fw-medium" 
                  onClick={() => {
                    setShowRevokeModal(false);
                    setPendingRevokeRecord(null);
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger btn-sm px-4 rounded-pill fw-semibold text-white shadow-sm d-inline-flex align-items-center"
                  onClick={handleRevokeSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
      {isModalLoading && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
          style={{ zIndex: 1060 }}
        >
          <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <span className="mt-3 fw-bold text-dark">Fetching Requisition Details...</span>
        </div>
      )}

      {/* TA Leads Modal */}
      <CandidateDetailsModal
        showModal={showLeadsModal}
        handleCloseModal={() => setShowLeadsModal(false)}
        modalData={selectedLeads.map(lead => ({
          ...lead,
          FullName: lead.CandidateName || "N/A",
          Status: lead.LatestStatus || "N/A"
        }))}
        modalContent={{
          RequisitionID: currentLeadReqCode,
          PrimaryHRName: "",
          SecondaryHRName: ""
        }}
        modalLoading={leadsLoading}
        isRmgLead={true}
        recruiterTitle="Recruiter Name"
        refreshData={null}
      />

      {/* Duplicate Confirmation Modal */}
      <Modal show={showDuplicateModal} onHide={() => setShowDuplicateModal(false)} centered size="sm">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold fs-6" style={{ color: "#27568B" }}>Confirm Duplication</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <p className="mb-0 text-center fs-6">Are you sure you want to duplicate this requirement?</p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pt-0 pb-4">
          <button className="cancel-btn px-4" onClick={() => setShowDuplicateModal(false)}>
            No
          </button>
          <button className="custom-btn px-4" onClick={handleDuplicateConfirm} disabled={isDuplicating}>
            {isDuplicating ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Duplicating...
              </>
            ) : (
              "Yes"
            )}
          </button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default CustomerRequirement;












